import { render, staticRenderFns } from "./VirtualWallComponent.vue?vue&type=template&id=01e1fa54&scoped=true&"
import script from "./VirtualWallComponent.vue?vue&type=script&lang=js&"
export * from "./VirtualWallComponent.vue?vue&type=script&lang=js&"
import style0 from "./VirtualWallComponent.vue?vue&type=style&index=0&id=01e1fa54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e1fa54",
  null
  
)

export default component.exports